import CustomerForm from './CustomerForm';
import AssignForm from './AssignForm';
import CustomersList from './CustomersList';

const UsersListConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/partners',
      element: <CustomersList />,
    },
    {
      path: '/addPartner',
      element: <CustomerForm />,
    },
    {
      path: '/editPartner/:id',
      element: <CustomerForm />,
    },
  ],
};

export default UsersListConfig;
